import React, { useState, useMemo } from "react";
import { Box, Typography, Grid } from "@mui/material";
import PrivacyImg from "./../../assets/images/privacy.png";
import ProtectionImg from "./../../assets/images/protection.png";
import TeamImg1 from "./../../assets/images/team-member-1.png";
import TeamImg2 from "./../../assets/images/team-member-2.png";
import AngleRightImg from "./../../assets/images/angle-right.png";
import SecurityImg from "./../../assets/images/security.png";
import RightArrow from "./../../assets/images/arrow-right-primary.png";
import { useTranslation } from "react-i18next";

const Testimonial = () => {
  const { t } = useTranslation();

  const [testimonial, setTestimonial] = useState(true);
  const toggle = () => setTestimonial((pre) => !pre);
  const { text, imgSrc } = useMemo(() => {
    const index = Number(testimonial);
    const tesmonials = [
      {
        text: t("testimonial-text-1"),
        imgSrc: TeamImg1,
      },
      {
        text: t("testimonial-text-2"),
        imgSrc: TeamImg2,
      },
    ];
    return tesmonials[index];
  }, [testimonial]);

  return (
    <Box pt={2} pb={6}>
      <Box sx={{ textAlign: "center" }}>
        <Typography mt={2} fontSize={"1.9rem"} fontWeight="bold" sx={{}} className="testimonial-heading">
          {t("testimonial-heading")}
        </Typography>

        <Grid container mt={5}>
          <Grid item xs={3} textAlign={"center"}>
            <Box as="img" src={imgSrc} width="60%" mt={0} />
            <Typography fontWeight={400} fontSize={"0.85rem"} className="testimonial-name">
              Kunde der Volksbank pur eG
            </Typography>
          </Grid>
          <Grid item xs={7} display={"flex"} alignItems={"center"}>
            <Typography textAlign={"left"} fontSize={"1.35rem"} className="testimonial-text">
              {text}
            </Typography>
          </Grid>
          <Grid
            item
            xs={2}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"flex-end"}
          >
            <Box
              as="img"
              height={45}
              src={AngleRightImg}
              sx={{ cursor: "pointer" }}
              onClick={toggle}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Testimonial;
